import dayjs from 'dayjs'

// Step the range by its own length so both endpoints move together:
// a single day steps 1 day, an N-day range steps N days.
export const shiftDateRange = (startDate: Date, endDate: Date, direction: 1 | -1): [Date, Date] => {
  const lengthDays = dayjs(endDate).startOf('day').diff(dayjs(startDate).startOf('day'), 'day') + 1
  const step = lengthDays * direction
  return [dayjs(startDate).add(step, 'day').toDate(), dayjs(endDate).add(step, 'day').toDate()]
}

// Compact range label that drops the parts repeated between the endpoints:
//   single day:                  Thu 16 May 2026
//   same month & year:           16 – 17 May 2026
//   different month, same year:  30 Apr – 2 May 2026
//   different year:              30 Dec 2025 – 2 Jan 2026
export const formatDateRangeLabel = (startDate: Date, endDate: Date): string => {
  const start = dayjs(startDate)
  const end = dayjs(endDate)
  if (start.isSame(end, 'day')) {
    return start.format('ddd D MMM YYYY')
  }
  if (start.isSame(end, 'month')) {
    return `${start.format('D')} – ${end.format('D MMM YYYY')}`
  }
  if (start.isSame(end, 'year')) {
    return `${start.format('D MMM')} – ${end.format('D MMM YYYY')}`
  }
  return `${start.format('D MMM YYYY')} – ${end.format('D MMM YYYY')}`
}
